import { ArrowUpRight } from 'public/icons/ArrowUpRight';
import { ReactNode } from 'react';
import cx from 'classnames';
import Typo from '../Typography';

type TArticleIntegrationLinkProps = {
  href: string;
  children: ReactNode;
  icon?: ReactNode;
  onClick?: () => void;
};

export const ArticleIntegrationLink = ({ children, icon, href, onClick }: TArticleIntegrationLinkProps) => (
  <div
    className={cx(
      'flex items-center justify-between w-full',
      'text-gray-400 text-[12px] lg:text-[14px] overflow-hidden truncate',
    )}
  >
    <div className="flex gap-3 min-w-0 shrink">
      <div className="w-5 h-5 grow shrink-0">{icon}</div>
      <div className="shrink overflow-hidden truncate">{children}</div>
    </div>
    <a
      className="grow shrink-0 md:grow-0 flex items-center gap-1 hover:underline"
      href={href}
      target="_blank"
      rel="noreferrer"
      onClick={onClick}
    >
      <Typo variant="p-large">View</Typo>
      <ArrowUpRight />
    </a>
  </div>
);
